import React, { Component } from 'react'

import ReactTable from "react-table"
import 'react-table/react-table.css'

import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'

import moment from 'moment'
import _ from 'lodash'
import requester from '../../../lib/requester'

class SummaryApproval extends Component {

  constructor(props) {
    super(props)
    this.state = {
      dataTable: []
    }
  }

  componentDidMount = () => {
    this.getSummaryApproval()
  }

  getSummaryApproval = () => {
    let url = '/api/traces_chd/v1/program/data-summary-approval'
    this.setState({ loading: true })
    requester.postCHD(url, {}, {
      success: function (response) {
        let { data } = response.data
        this.setState({ loading: false, dataTable: data })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }
  renderTable = () => {
    const data = {
      columns: [
        {
          Header: 'PROGRAM NO',
          accessor: 'program_number',
          filterable: true
        },
        {
          Header: 'REF NO',
          accessor: 'ref_number',
          filterable: true
        },
        {
          Header: 'PROGRAM TYPE',
          accessor: 'program_name',
          filterable: true
        },
        {
          Header: 'PROGRAM DESCRIPTION',
          accessor: 'description',
          filterable: true
        },
        {
          Header: 'COMPANY',
          accessor: 'org_name',
          filterable: true
        },
        {
          Header: 'SUBMITTED DATE',
          accessor: 'creation_date',
          className: 'text-right',
          Cell: row => (
            <span>
              <span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss") : ""}
              </span>
            </span>
          ),
          filterable: true
        },
        {
          Header: '',
          accessor: 'program_id',
          Cell: row => (
            <span>
              <button className="btn btn-info btn-sm" onClick={() => { this.goDetail(row) }}><i className="fa fa-eye" /> View Program</button>
            </span>
          )
        }
      ],
      rows: this.state.dataTable

    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
      defaultFilterMethod={((filter, row, column) => {
        let columnes = row[filter.id]
        return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
      })}
    />)
  }

  goDetail = (rows) => {
    let { row } = rows
    this.props.history.push('/admin/program-chd/approval/' + row.program_id)
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12">
                        {this.renderTable()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default SummaryApproval